export const accountBalanceUpdated = (state, action) => {
    state.userAccount.availableBalance = action.payload.Balances["*"];
    state.userAccount.availableCash = action.payload.Balances['US'];
    state.userAccount.availableEuro = action.payload.Balances['EUR'];
    state.userAccount.availableMXN = action.payload.Balances['MXN'];
    state.userAccount.availableTFCash = action.payload.Balances['TF'];
    state.userAccount.availableTFMXN = action.payload.Balances['TF_MXN'];

    state.userAccountProfileState.updated = true;
    state.userAccountProfileState.eventName = action.payload.EventName;
}

export const accountAddressChanged = (state, action) => {
    state.userAccount.address.addressId = action.payload.addressId;
    state.userAccount.address.address1 = action.payload.address1;
    state.userAccount.address.address2 = action.payload.address2;
    state.userAccount.address.city = action.payload.city;
    state.userAccount.address.state = action.payload.state;
    state.userAccount.address.country = action.payload.country;
    state.userAccount.address.zipCode = action.payload.zipCode;
    state.userAccount.address.phone1 = action.payload.phone1;
    state.userAccount.address.phone2 = action.payload.phone2;
    state.userAccount.address.countryCode = action.payload.countryCode;
    state.userAccount.address.citizenshipCountryCode = action.payload.citizenshipCountryCode;
    state.userAccount.address.stateCode = action.payload.stateCode;

    state.userAccountProfileState.updated = true;
    state.userAccountProfileState.eventName = action.payload.EventName;
}

export const accountDetailsChanged = (state, action) => {
    action.payload.Changes.forEach(c => {
        switch (c.Name) {
            case "FirstName":
                state.userAccount.firstName = c.newValue;
                break;
            case "LastName":
                state.userAccount.lastName = c.newValue;
                break;
            case "Email":
                state.userAccount.email = c.newValue;
                break;
            case "Pseudonym":
                state.userAccount.pseudonym = c.newValue;
                break;
        }
    });
    state.userAccountProfileState.updated = true;
    state.userAccountProfileState.eventName = action.payload.EventName;
}

export const accountPreferencesChanged = (state, action) => {
    action.payload.Changes.forEach(c => {
        switch (c.Name) {
            case "FollowersAutoAccept":
                state.userAccount.preferences.followersAutoAccept = c.newValue;
                break;
            case "FilledOrderEmails":
                state.userAccount.preferences.filledOrderEmails = c.newValue;
                break;
            case "FollowingRequestEmails":
                state.userAccount.preferences.followingRequestEmails = c.newValue;
                break;
            case "ShowOrderConfirmation":
                state.userAccount.preferences.showOrderConfirmation = c.newValue;
                break;
        }
    });
}

export const accountAddressChangeFailed = (state, action) => {
    state.userAccountProfileState.updated = true;
    state.userAccountProfileState.eventName = action.payload.EventName;
}